import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getDoneWorksLinks(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_LINKS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].GET_DONE_WORKS_LINKS,
		options
	)
}
function _getDoneWorksLinkPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_LINKS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].GET_DONE_WORKS_LINK_PREVIEW,
		options
	)
}
function _getDoneWorksLinkPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_LINKS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].GET_DONE_WORKS_LINK_POPUP,
		options
	)
}

function _createDoneWorksLink(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_LINKS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].CREATE_DONE_WORKS_LINK,
		options
	)
}

function _getDoneWorksLink(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_LINKS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].GET_DONE_WORKS_LINK,
		options
	)
}

function _patchDoneWorksLink(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_LINKS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].PATCH_DONE_WORKS_LINK,
		options
	)
}

function _putDoneWorksLink(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_LINKS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].PUT_DONE_WORKS_LINK,
		options
	)
}

function _deleteDoneWorksLink(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_LINKS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].DELETE_DONE_WORKS_LINK,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].GET_DONE_WORKS_LINKS]: _getDoneWorksLinks,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].GET_DONE_WORKS_LINK_PREVIEW]: _getDoneWorksLinkPreview,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].GET_DONE_WORKS_LINK_POPUP]: _getDoneWorksLinkPopup,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].CREATE_DONE_WORKS_LINK]: _createDoneWorksLink,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].GET_DONE_WORKS_LINK]: _getDoneWorksLink,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].PATCH_DONE_WORKS_LINK]: _patchDoneWorksLink,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].PUT_DONE_WORKS_LINK]: _putDoneWorksLink,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].DELETE_DONE_WORKS_LINK]: _deleteDoneWorksLink,
}